import { render, staticRenderFns } from "./PopupPlsAddProduct.vue?vue&type=template&id=88fd148a&scoped=true"
import script from "./PopupPlsAddProduct.vue?vue&type=script&lang=js"
export * from "./PopupPlsAddProduct.vue?vue&type=script&lang=js"
import style0 from "./PopupPlsAddProduct.vue?vue&type=style&index=0&id=88fd148a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd148a",
  null
  
)

export default component.exports